function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ActionButton from '@nextcloud/vue/dist/Components/ActionButton';
import AppContent from '@nextcloud/vue/dist/Components/AppContent';
import AppNavigation from '@nextcloud/vue/dist/Components/AppNavigation';
import AppNavigationCaption from '@nextcloud/vue/dist/Components/AppNavigationCaption';
import AppNavigationCounter from '@nextcloud/vue/dist/Components/AppNavigationCounter';
import AppNavigationItem from '@nextcloud/vue/dist/Components/AppNavigationItem';
import AppNavigationNew from '@nextcloud/vue/dist/Components/AppNavigationNew';
import AppNavigationSettings from '@nextcloud/vue/dist/Components/AppNavigationSettings';
import axios from '@nextcloud/axios';
import Content from '@nextcloud/vue/dist/Components/Content';
import { generateUrl } from '@nextcloud/router';
import Multiselect from '@nextcloud/vue/dist/Components/Multiselect';
import Vue from 'vue';
import VueLocalStorage from 'vue-localstorage';
import UserList from '../components/UserList';
Vue.use(VueLocalStorage);
export default {
  name: 'Users',
  components: {
    ActionButton: ActionButton,
    AppContent: AppContent,
    AppNavigation: AppNavigation,
    AppNavigationCaption: AppNavigationCaption,
    AppNavigationCounter: AppNavigationCounter,
    AppNavigationItem: AppNavigationItem,
    AppNavigationNew: AppNavigationNew,
    AppNavigationSettings: AppNavigationSettings,
    Content: Content,
    Multiselect: Multiselect,
    UserList: UserList
  },
  props: {
    selectedGroup: {
      type: String,
      default: null
    }
  },
  data: function data() {
    return {
      // default quota is set to unlimited
      unlimitedQuota: {
        id: 'none',
        label: t('settings', 'Unlimited')
      },
      // temporary value used for multiselect change
      selectedQuota: false,
      externalActions: [],
      loadingAddGroup: false,
      loadingSendMail: false,
      showConfig: {
        showStoragePath: false,
        showUserBackend: false,
        showLastLogin: false,
        showNewUserForm: false,
        showLanguages: false
      }
    };
  },
  computed: {
    selectedGroupDecoded: function selectedGroupDecoded() {
      return this.selectedGroup ? decodeURIComponent(this.selectedGroup) : null;
    },
    users: function users() {
      return this.$store.getters.getUsers;
    },
    groups: function groups() {
      return this.$store.getters.getGroups;
    },
    usersOffset: function usersOffset() {
      return this.$store.getters.getUsersOffset;
    },
    usersLimit: function usersLimit() {
      return this.$store.getters.getUsersLimit;
    },
    // Local settings
    showLanguages: {
      get: function get() {
        return this.getLocalstorage('showLanguages');
      },
      set: function set(status) {
        this.setLocalStorage('showLanguages', status);
      }
    },
    showLastLogin: {
      get: function get() {
        return this.getLocalstorage('showLastLogin');
      },
      set: function set(status) {
        this.setLocalStorage('showLastLogin', status);
      }
    },
    showUserBackend: {
      get: function get() {
        return this.getLocalstorage('showUserBackend');
      },
      set: function set(status) {
        this.setLocalStorage('showUserBackend', status);
      }
    },
    showStoragePath: {
      get: function get() {
        return this.getLocalstorage('showStoragePath');
      },
      set: function set(status) {
        this.setLocalStorage('showStoragePath', status);
      }
    },
    userCount: function userCount() {
      return this.$store.getters.getUserCount;
    },
    settings: function settings() {
      return this.$store.getters.getServerData;
    },
    // default quota
    quotaOptions: function quotaOptions() {
      // convert the preset array into objects
      var quotaPreset = this.settings.quotaPreset.reduce(function (acc, cur) {
        return acc.concat({
          id: cur,
          label: cur
        });
      }, []); // add default presets

      quotaPreset.unshift(this.unlimitedQuota);
      return quotaPreset;
    },
    // mapping saved values to objects
    defaultQuota: {
      get: function get() {
        if (this.selectedQuota !== false) {
          return this.selectedQuota;
        }

        if (this.settings.defaultQuota !== this.unlimitedQuota.id && OC.Util.computerFileSize(this.settings.defaultQuota) >= 0) {
          // if value is valid, let's map the quotaOptions or return custom quota
          return {
            id: this.settings.defaultQuota,
            label: this.settings.defaultQuota
          };
        }

        return this.unlimitedQuota; // unlimited
      },
      set: function set(quota) {
        this.selectedQuota = quota;
      }
    },
    sendWelcomeMail: {
      get: function get() {
        return this.settings.newUserSendEmail;
      },
      set: function set(value) {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _this.loadingSendMail = true;

                  _this.$store.commit('setServerData', _objectSpread({}, _this.settings, {
                    newUserSendEmail: value
                  }));

                  _context.next = 5;
                  return axios.post(generateUrl("/settings/users/preferences/newUser.sendEmail"), {
                    value: value ? 'yes' : 'no'
                  });

                case 5:
                  _context.next = 10;
                  break;

                case 7:
                  _context.prev = 7;
                  _context.t0 = _context["catch"](0);
                  console.error('could not update newUser.sendEmail preference: ' + _context.t0.message, _context.t0);

                case 10:
                  _context.prev = 10;
                  _this.loadingSendMail = false;
                  return _context.finish(10);

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 7, 10, 13]]);
        }))();
      }
    },
    groupList: function groupList() {
      var _this2 = this;

      var groups = Array.isArray(this.groups) ? this.groups : [];
      return groups // filter out disabled and admin
      .filter(function (group) {
        return group.id !== 'disabled' && group.id !== 'admin';
      }).map(function (group) {
        return _this2.formatGroupMenu(group);
      });
    },
    adminGroupMenu: function adminGroupMenu() {
      return this.formatGroupMenu(this.groups.find(function (group) {
        return group.id === 'admin';
      }));
    },
    disabledGroupMenu: function disabledGroupMenu() {
      return this.formatGroupMenu(this.groups.find(function (group) {
        return group.id === 'disabled';
      }));
    }
  },
  beforeMount: function beforeMount() {
    this.$store.commit('initGroups', {
      groups: this.$store.getters.getServerData.groups,
      orderBy: this.$store.getters.getServerData.sortGroups,
      userCount: this.$store.getters.getServerData.userCount
    });
    this.$store.dispatch('getPasswordPolicyMinLength');
  },
  created: function created() {
    // init the OCA.Settings.UserList object
    // and add the registerAction method
    Object.assign(OCA, {
      Settings: {
        UserList: {
          registerAction: this.registerAction
        }
      }
    });
  },
  methods: {
    toggleNewUserMenu: function toggleNewUserMenu() {
      this.showConfig.showNewUserForm = !this.showConfig.showNewUserForm;

      if (this.showConfig.showNewUserForm) {
        Vue.nextTick(function () {
          window.newusername.focus();
        });
      }
    },
    getLocalstorage: function getLocalstorage(key) {
      // force initialization
      var localConfig = this.$localStorage.get(key); // if localstorage is null, fallback to original values

      this.showConfig[key] = localConfig !== null ? localConfig === 'true' : this.showConfig[key];
      return this.showConfig[key];
    },
    setLocalStorage: function setLocalStorage(key, status) {
      this.showConfig[key] = status;
      this.$localStorage.set(key, status);
      return status;
    },
    removeGroup: function removeGroup(groupid) {
      var self = this; // TODO migrate to a vue js confirm dialog component

      OC.dialogs.confirm(t('settings', 'You are about to remove the group {group}. The users will NOT be deleted.', {
        group: groupid
      }), t('settings', 'Please confirm the group removal '), function (success) {
        if (success) {
          self.$store.dispatch('removeGroup', groupid);
        }
      });
    },

    /**
     * Dispatch default quota set request
     *
     * @param {string|Object} quota Quota in readable format '5 GB' or Object {id: '5 GB', label: '5GB'}
     */
    setDefaultQuota: function setDefaultQuota() {
      var _this3 = this;

      var quota = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'none';
      this.$store.dispatch('setAppConfig', {
        app: 'files',
        key: 'default_quota',
        // ensure we only send the preset id
        value: quota.id ? quota.id : quota
      }).then(function () {
        if (_typeof(quota) !== 'object') {
          quota = {
            id: quota,
            label: quota
          };
        }

        _this3.defaultQuota = quota;
      });
    },

    /**
     * Validate quota string to make sure it's a valid human file size
     *
     * @param {string} quota Quota in readable format '5 GB'
     * @returns {Promise|boolean}
     */
    validateQuota: function validateQuota(quota) {
      // only used for new presets sent through @Tag
      var validQuota = OC.Util.computerFileSize(quota);

      if (validQuota === null) {
        return this.setDefaultQuota('none');
      } else {
        // unify format output
        return this.setDefaultQuota(OC.Util.humanFileSize(OC.Util.computerFileSize(quota)));
      }
    },

    /**
     * Register a new action for the user menu
     *
     * @param {string} icon the icon class
     * @param {string} text the text to display
     * @param {Function} action the function to run
     * @returns {Array}
     */
    registerAction: function registerAction(icon, text, action) {
      this.externalActions.push({
        icon: icon,
        text: text,
        action: action
      });
      return this.externalActions;
    },

    /**
     * Create a new group
     *
     * @param {string} gid The group id
     */
    createGroup: function createGroup(gid) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(gid.trim() === '')) {
                  _context2.next = 3;
                  break;
                }

                Vue.nextTick(function () {
                  _this4.toggleAddGroupEntry(true);
                });
                return _context2.abrupt("return");

              case 3:
                _context2.prev = 3;
                _this4.loadingAddGroup = true;
                _context2.next = 7;
                return _this4.$store.dispatch('addGroup', gid.trim());

              case 7:
                _this4.toggleAddGroupEntry(false);

                _this4.$router.push({
                  name: 'group',
                  params: {
                    selectedGroup: encodeURIComponent(gid.trim())
                  }
                });

                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](3);

                _this4.toggleAddGroupEntry(true);

              case 14:
                _context2.prev = 14;
                _this4.loadingAddGroup = false;
                return _context2.finish(14);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 11, 14, 17]]);
      }))();
    },

    /**
     * Toggle the add group entry editing state
     * @param {boolean} [state] set state instead of toggling
     */
    toggleAddGroupEntry: function toggleAddGroupEntry(state) {
      var _this5 = this;

      if (state === undefined) {
        state = !this.$refs.addGroup.editing;
      }

      this.$refs.addGroup.editing = state; // focus input

      Vue.nextTick(function () {
        if (_this5.$refs.addGroup.$el) {
          var input = _this5.$refs.addGroup.$el.querySelector('form > input[type="text"]');

          if (input) {
            input.focus();
          }
        }
      });
    },

    /**
     * Format a group to a menu entry
     * @param {Object} group the group
     * @returns {Object}
     */
    formatGroupMenu: function formatGroupMenu(group) {
      var item = {};

      if (typeof group === 'undefined') {
        return {};
      }

      item.id = group.id;
      item.title = group.name;
      item.usercount = group.usercount; // users count for all groups

      if (group.usercount - group.disabled > 0) {
        item.count = group.usercount - group.disabled;
      }

      return item;
    }
  }
};